import React, {Component} from 'react';
import {Link} from 'react-router-dom';

// Layout
import Header from "../layout/header/header1";
import ContactInfoCard from '../elements/contact-info-card';

class Skolanskaraktar extends Component{
	
	render(){
		return (
			<>
				
				<Header />
				
				<div className="page-content">					
					<div className="content-block">
						<div className="section-area section-sp2">
							<div className="container">
								<div className="row">
								<div className="col-md-12 heading-bx left">
								<h2 className="title-head">Skolans karaktär</h2>
							</div>
									<div className="col-lg-8 col-xl-8">
										<div className="recent-news blog-lg">
											<div className="info-bx">
												
						<h4>Kista international School - en dikt</h4>
											<br/>
												<p>Tio år av kunskap och vänskapens band, i Kista International School vi står hand i hand. Ett jubileum av glädje och framgång vi firar nu, en gemenskap starkare än något annat nån sett eller hört.</p>
                        <br/>
                        <p>I hjärtat av Kista, vår skola står stark, elever från hela världen, tillsammans i ett ark. Vi har kommit från när och fjärran, men här finner vi en fristad, vår andra förlängda famn.</p>
                        <br/>
                        <p>Språk och kultur, en levande kavalkad, vi lär oss av varandra, utan fördomar vi går framåt. Somaliska, svenska och arabiska, en språklig mångfald, vi uttrycker oss på olika sätt, men ändå förstår varann.</p>
                        <br/>
                        <p>Lärare som lysande stjärnor av inspirationens sken, de guidar oss genom den kunskapens ven. Med tålamod och kärlek, de formar vårt sinne,vi är tacksamma för deras visdom, vår viktigaste vinst.</p>
						<br/>
						<p>Tio år har svischat förbi, som en vind, vi ser tillbaka på minnen som låter oss minnas och låter oss få tårar. Vi har lärt oss så mycket, kedjor har brutits, vi står som modiga individer, förenade och på språng.</p>
						<br/>
						<p>Jubileums jubel fyller våra hjärtan med glädje, vi firar vår framgång och framtiden är redo. Kista International School, vår andra hemort, tio år av vänskap och kunskap, vi växer tillsammans, i harmoni.</p>
						<br/>
						<p>En skola för alla, där vi är eniga om vår kultur. En inkludering där både jag och du är vi. Vi är för alla tills slutet. Vi är med i skapandet när det kommer till lärdomen, tillhörigheten och gemenskapen.</p>
						<br/>
						<p>Vägen till likvärdighet där alla dörrar finns öppna för dig. Du är framtiden. Vi är framtiden. Vi är de som ska synas och höras.</p>
						<br/>
						<p>Här i Kista International Schools korridorer var början på något stort. Där elevens vilja är starkast. Där slutet är även början. Där mörkret är även ljuset. Där vänskap för livet börjar. Där ljuset aldrig slocknar.</p>
						<br/>
						<p>Ett band för livet. En vänskap för livet. Sedan barnsben och framåt. En sådan vänskap är en unik gåva som man aldrig vill släppa. Från hand till hand, hjärta till hjärta är vi ett.</p>
						<br/>
						<p> <em>Huda Jamal Baris, elev årskurs 6</em> </p>
						<br/>
						<h4>Kista International School celebrating 10 years</h4>
						<br/>
						<p>Me, here and now,</p>
						<p>Years have gone by</p>
						<p>time has separated many amongst us.</p>
						<p>A place that one feels free,</p>
						<p>a building that is as old as me.</p>
						<p>Each morning we come in with a smile</p>
						<p>every evening we leave satisfied.</p>
						<p>A promise to do our best.</p>
						<p>Proud of what we have achieved</p>
						<p>both students and teachers alike.</p>
						<p>Sharing our dreams, feeling a sense of community</p>
						<p>we work, learn and play.</p>
						<p>Listen here, in spite of what the critics say</p>
						<p>noise in the corridors, running footsteps and banging doors.</p>
						<p>Calmly we walk, our yellow vests on and hear</p>
						<p>students memorizing by rote, loud and clear.</p>
						<p>Loads of books to read in our library,</p>
						<p>a prevailing sense of opportunity and unity.</p>
						<p>One feels a sense of belonging</p>
						<p>my school, my workplace.</p>
						<p>A place that I call my second home.</p>
						<p>Where teachers ignite the flame of ambition,</p>
						<p>where students are kind and compassionate.</p>
						<p>Ten years have gone by,</p>
						<p>a lifetime for many, but just a decade for me.</p>
						<p> <em>Mithra Pai, lärare matematik och engelska</em> </p>
						<br/><h4>“We Stand”</h4><br/>
						<p>It all started with a vision, Kista International School was risen. We opened in 2010 and students started writing with their pen. Traveling near and far on a school bus, your education is very important to us.</p>
						<br/> 
						<p>The students gain knowledge through education, while the brushes from art foster your creation. The staff creates learning that is essential for the students to reach goals and their full potential</p>
						<br/> 
						<p>Our playground provides fun and healthy needs which allows students to enjoy laugh and sing. From young to older students we help to create respectful and prudent students. For this we are very proud, now it’s time to yell we are the best out loud.</p>  
						<br/>
						<p>On the count of three, everybody say it with me, Kista International School is the best</p>
						<p>1…2….3   Kista International School is the best!!!</p>
						<br/>
						<p> <em>Yerosalim Asgodom, kurator</em> </p>
                      </div>
										</div>
									</div>
									
								</div>
							</div>
						</div>
						
					</div>
					
				</div>
				
				<ContactInfoCard/>
				
			</>
		);
	}
}

export default Skolanskaraktar;